module.exports = __webpack_public_path__ + "static/logo-long-3a8cbbf1cc72becb7f871adc8fd64474.png";